module.exports = __webpack_public_path__ + "img/forget_pwd_bg.27e8bb2e.png";